import { CreateUnstyledTextFieldEditor } from '../../canvas/workspace/adapters/UnstyledTextFieldEditor';
import { Connector } from './Connector';
import { ConnectorLabelTextSettings } from './ConnectorLayout';

const ConnectorLabelFieldEditor = CreateUnstyledTextFieldEditor('label', () => ConnectorLabelTextSettings);

export const ConnectorLabelField = (owner: Connector) => ({
    ui: ConnectorLabelFieldEditor,
    name: 'label',
    bounds: owner.layout.label,
    owner,
});
